<template>
  <div class="fy-calendar">
    <!-- placeholder="选择日期" -->
    <date-picker
      :default-value="new Date()"
      :picker-options="getPickerOptions"
      :value-format="value_format"
      size="mini"
      type="date"
      v-model="d_value"
    >
      <!-- large, small, mini -->
    </date-picker>
  </div>
</template>
<script>
//TODO [xsw] 日期选择组件是否还需要加验证？？
import util from '../utils/util.js'
import { DatePicker } from 'element-ui'
export default {
  name: 'FyElDate',
  componentName: 'FyElDate',
  components: {
    DatePicker
  },
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）
  inject: {
    //获取父元素的provide中的值
    fyForm: {
      default: ''
    },
    fyFormItem: {
      default: ''
    }
  },
  data () {
    return {
      d_value: this.value
    }
  },
  props: {
    value_format: {
      type: String,
      default: 'timestamp'
    },
    value: {
      type: Number,
      default: null
    },
    start_date: {
      type: Number,
    },
    end_date: {
      type: Number
    }
  },
  created () {
    this.d_value = this.d_value == 0 ? null : this.d_value
  },
  mounted () {
    this.dispatch('FyFormItem', 'formItem.addChildVc', [this]) //发送添加formitem对象的信息
  },
  computed: {
    getPickerOptions () {
      let start_date = this.start_date - 1000 * 60 * 60 * 24
      let end_date = this.end_date
      let pickerOptions = {
        disabledDate (time) {
          if (start_date && end_date) {
            return time.getTime() < start_date || time.getTime() > end_date
          } else if (start_date || end_date) {
            if (start_date) {
              return time.getTime() < start_date
            }
            else {
              return time.getTime() > end_date
            }
          } else {
            return null
          }
        }
      }
      return pickerOptions
    }
  },
  watch: {
    value (val) {
      this.d_value = val
    },
    d_value (value) {
      this.$emit('input', value)
      this.handleChange(value)
    }
  },
  methods: {
    //选择日期后的回调
    handleChange (value) {
      this.dispatch('FyFormItem', 'el.form.change', [value])
    },
  }
}
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>



// WEBPACK FOOTER //
// src/components/form/elementDate.vue